import { render, staticRenderFns } from "./AlbumOwnerIndicator.vue?vue&type=template&id=1ad05d84&scoped=true&"
import script from "./AlbumOwnerIndicator.vue?vue&type=script&lang=js&"
export * from "./AlbumOwnerIndicator.vue?vue&type=script&lang=js&"
import style0 from "./AlbumOwnerIndicator.vue?vue&type=style&index=0&id=1ad05d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad05d84",
  null
  
)

export default component.exports